import React, {useState}from 'react'

import './Footer.scss'
import {images} from '../../constants'
import {AppWrap, MotionWrap} from '../../wrapper'
import {client} from '../../client'

const Footer = () => {
  const [formData, setFormData] = useState({name:'', email:'', message:''})
  const [isFormSubmitted, setIsFormSubmitted] = useState(false)
  const [loading, setLoading] = useState(false)
  const {name, email, message} =formData;

  const HandleChangeInput = (e) =>{
    const {name, value} = e.target;
    setFormData({...formData, [name]: value})
  }
  
  const handleSubmit = () =>{
    setLoading(true);
    const contact ={
      _type: 'contact',
      name:name,
      email: email,
      message: message
    }
    client.create(contact)
    .then(() =>{
      setLoading(false);
      setIsFormSubmitted(true)
    })
  }
  return (
    <>
     <h2 className="head-text">Take a coffee & chat with me</h2> 
     <div className="app__footer-cards">
       <div className="app__footer-card">
         <img src={images.email} alt='email'/>
         <a href="mailto:didieudi@gmail.com" className='app-text'>Send me an email</a>
       </div>
       <div className="app__footer-card">
         <img src={images.mobile} alt='mobile'/>
         <a href="tel: +250787902" className='app-text'> +250787087902</a>
       </div>
     </div>
      
      {!isFormSubmitted ?
      
     <div className="app__footer-form app__flex">
       <div className='app__flex'>
         <input className='p-text' type='text' placeholder="Your name" name="name" value={name} onChange={HandleChangeInput}/>
       </div>
       <div className='app__flex'>
         <input className='p-text' type='email' placeholder="Your Email" name="email" value={email} onChange={HandleChangeInput}/>
       </div>
       <div>

       <textarea 
       className="p-text"
       placeholder="Your message"
       value={message}
       name="message"
       onChange={HandleChangeInput}
       />
       
       </div>
       <button type="submit" className="p-text" onClick={handleSubmit}>{loading ? 'Sending' : 'Send Message'}</button>
     </div>
     : <div>
       <h3 className="head-text"> Thank you for getting in touch!</h3>
     </div>
    }
     
    </>
  )
}

export default AppWrap(
  MotionWrap(Footer, 'app__footer'), 
   "Contact",
   "app__whitebg"
   )
 